/**
 * "Unpinned" embedding model versions: placeholder strings that were never
 * adopted from a real encoder response.
 *
 * The DINO encoder is authoritative — it reports the version it actually
 * loaded (`<model>-<commit>`, e.g. `dinov3-vits16-5931719`) and ignores the
 * version a caller requests. A reference carrying one of the placeholders
 * below was therefore never pinned to a real model, so it cannot signal a
 * genuine version mismatch:
 *
 *   - `''`                — the empty default before any capture.
 *   - `dinov3-vits16-v1`  — the legacy seed default predating version tracking.
 *
 * Callers comparing a stored `embeddingModelVersion` against the live encoder
 * should treat these as "adopt the live version", not "mismatch" — otherwise a
 * brand-new or legacy-seeded skill is stranded behind a false mismatch it can
 * never clear without re-teaching.
 */
export const UNPINNED_MODEL_VERSIONS = new Set(['', 'dinov3-vits16-v1']);

/**
 * True when `version` is a placeholder that was never pinned to a real encoder
 * capture (see {@link UNPINNED_MODEL_VERSIONS}).
 */
export function isUnpinnedModelVersion(version: string): boolean {
  return UNPINNED_MODEL_VERSIONS.has(version);
}
